import TextEditor from "../components/cflow/TextEditor";
import BannerEditor from "../components/cflow/BannerEditor";
import FlowForm from "../components/cflow/FlowForm";
import skeleton from "../components/cflow/Skeleton";

export default {
  install(Vue) {
    Vue.component(TextEditor.name, TextEditor);
    Vue.component(FlowForm.name, FlowForm);
    Vue.component(BannerEditor.name, BannerEditor);
    Vue.component('skeleton', skeleton);
  }
};
